module.exports = __webpack_public_path__ + "img/001.360f37df.png";